// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    itemList: {},
    newParam:{},
    advancedQuery:[],
    neardQuery:[],
    searchFilter:[],
  },
  mutations: {
    setItem(state, itemList) {
      state.itemList = itemList
    },
    setNewParam(state, newParam) {
      state.newParam = newParam
    },
    setAdvancedQuery(state, advancedQuery) {
      state.advancedQuery = advancedQuery
    },
    setNeardQuery(state, neardQuery) {
      state.neardQuery = neardQuery
    },
    setSearchFilter(state, searchFilter) {
      state.searchFilter = searchFilter
    },

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js